<template>
  <div class="row">
    <div class="sixty">
      <div class="envn" style="margin-left:10px">
        <div v-show="reset">
          <h2>Forgot your password to The Slate?</h2>
          <label for="email">Your email address</label>
          <input v-model="email" type="email" id="email" autocomplete="email">
          <button @click="forgottenPass(email)" style="margin-left:0">We'll remind you</button>
        </div>
        <div v-show="sent">
          <h3>There's a verification code that's been sent.</h3>
        </div>
      </div>
    </div>
    <div class="thirty" style="margin-left:auto; background-color:#fff">
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
export default {
  name: 'forgotten-password',
  data () {
    return {
      email: "",
      loginError: false,
      sent: false,
      reset: true
    }
  },
  methods: {
    forgottenPass: async function (email) {
      this.removeError();
  	  Auth.forgotPassword(email)
  		  .then(data => this.sent = true, this.reset = false)
  		  .catch(err => console.log(err));
    },
    removeError: function (){
      this.loginError = false
    }
  }
}
</script>
